export default "__VITE_ASSET__C9hmM48J__"